import { Action, createReducer, on } from '@ngrx/store';
import { ApiRequestType } from 'src/app/shared/enums/api.enums';
import { apiResponse, postApiRequest } from '../api/api.actions';
import { isApi } from '../api/api.utilities';
import {
	setDefaultLanguage,
	updateMerchantDetailsAction,
	updateOrderMerchantDetailsAction,
} from './merchant-details.actions';
import { initialState, MerchantDetailsState } from './merchant-details.state';

const { GET_MERCHANT_DETAILS } = ApiRequestType;

const reducer = createReducer(
	initialState,
	on(postApiRequest, (state, action) => {
		if (!isApi(action, GET_MERCHANT_DETAILS)) {
			return state;
		}
		return { ...state, loaded: false, loading: true, errorLoading: false };
	}),
	on(setDefaultLanguage, (state, action) => ({
		...state,
		defaultLanguage: action.language,
	})),
	on(apiResponse, (state, action) => {
		if (!isApi(action, GET_MERCHANT_DETAILS)) {
			return state;
		}

		if (!action.isOk) {
			return { ...state, loaded: false, loading: false, errorLoading: true };
		}
		return { ...state, loaded: true, loading: false, errorLoading: false };
	}),
	on(updateMerchantDetailsAction, (state, action) => ({ ...state, merchant: action.merchant })),
	on(updateOrderMerchantDetailsAction, (state, action) => ({ ...state, orderMerchant: action.merchant }))
);

/**
 * Our main reducer for application config feature
 * @param state The current state
 * @param action The action being triggered
 */
export function merchantDetailsReducer(state: MerchantDetailsState, action: Action): MerchantDetailsState {
	return reducer(state, action);
}
